import { Injectable, inject } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
import { enUS, enGB, nl, de, fr, fi, Locale } from 'date-fns/locale';

@Injectable()
export class DateFnsDatepickerI18nService extends NgbDatepickerI18n {
  private translate = inject(TranslateService);

  getWeekdayLabel(weekday: number): string {
    const date = new Date(2020, 5, weekday);
    return format(date, 'EEEEE', { locale: this.getDateFnsLocale() });
  }

  getMonthShortName(month: number): string {
    const date = new Date(2020, month - 1, 1);
    return format(date, 'MMM', { locale: this.getDateFnsLocale() });
  }

  getMonthFullName(month: number): string {
    const date = new Date(2020, month - 1, 1);
    return format(date, 'MMMM', { locale: this.getDateFnsLocale() });
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const d = new Date(date.year, date.month - 1, date.day);
    return format(d, 'PPPP', { locale: this.getDateFnsLocale() }); // volledig datumlabel voor screenreaders
  }

  private getDateFnsLocale(): Locale {
    switch (this.translate.getCurrentLang()) {
      case 'nl-NL':
        return nl;
      case 'de-DE':
        return de;
      case 'fr-FR':
        return fr;
      case 'fi-FI':
        return fi;
      case 'en-US':
        return enUS;
      case 'en-GB':
        return enGB;
      default:
        return enUS;
    }
  }
}
